import { collection } from '../infra/collection'
import { SearchableUserDTO } from './dtos/searchable-user'
import { SearchableUser } from './models/SearchableUser'
import { IAMAPI } from './API'
import { CursorPaged, CursorPageQuery } from '../types/definitions'

export interface FetchUsersQuery extends CursorPageQuery {
  limit?: number
  search_text?: string
  after?: string | null
  user_types?: string[]
  workspace_id?: string
}

export default class SearchableUserStore {
  searchableUsers = collection<SearchableUserDTO, SearchableUser>({
    create: () => new SearchableUser(),
    getDataId: (data) => data.public_id,
    getModelId: (model) => model.publicId,
  })

  constructor(private api: IAMAPI) {}

  async fetchUsers(
    query: FetchUsersQuery
  ): Promise<CursorPaged<SearchableUser>> {
    const results = await this.api.userSearch.find(query)

    return {
      ...results,
      data: this.searchableUsers.set(results.data),
    }
  }
}
